import { render } from "./BusPositions.vue?vue&type=template&id=5655d99e"
import script from "./BusPositions.vue?vue&type=script&lang=js"
export * from "./BusPositions.vue?vue&type=script&lang=js"

import "./BusPositions.vue?vue&type=style&index=0&id=5655d99e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__